if (!customElements.get('pack-deal-block')) {
  class PackDealBlock extends HTMLElement {
    connectedCallback() {
      const variantsScript = this.querySelector('[data-pack-deal-variants]');
      this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

      this.variantPriceById = new Map();
      this.variantCompareAtById = new Map();
      this.variants.forEach((variant) => {
        this.variantPriceById.set(variant.id, Math.round(parseFloat(variant.price)));
        this.variantCompareAtById.set(variant.id, Math.round(parseFloat(variant.compare_at_price)) || 0);
      });
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';

      const choiceProductsScript = this.querySelector('[data-pack-deal-choice-products]');
      this.choiceProductsById = new Map();
      if (choiceProductsScript) {
        JSON.parse(choiceProductsScript.textContent).forEach((entry) => {
          this.choiceProductsById.set(entry.id, entry);
          entry.variants.forEach((variant) => {
            this.variantPriceById.set(variant.id, Math.round(parseFloat(variant.price)));
            this.variantCompareAtById.set(variant.id, Math.round(parseFloat(variant.compare_at_price)) || 0);
          });
        });
      }

      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      this.submitButton = this.querySelector('[data-add-to-cart]');
      this.errorEl = this.querySelector('[data-error]');

      this.currentVariantId = this.dataset.currentVariantId ? Number(this.dataset.currentVariantId) : null;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event?.data?.variant?.id) return;
          this.currentVariantId = event.data.variant.id;
          this.tiers.forEach((tier) => {
            if (tier.querySelectorAll('[data-row]').length === 0) this.computeTierPrice(tier);
          });
        });
      }

      this.tiers.forEach((tier) => {
        const radio = tier.querySelector('.pack-deal__radio-input');
        radio?.addEventListener('change', () => this.onTierChange());

        tier.querySelectorAll('[data-row]').forEach((row) => this.wireRow(row));
      });

      this.tiers.forEach((tier) => {
        tier.querySelectorAll('[data-row]').forEach((row) => this.resolveRow(row));
        this.computeTierPrice(tier);
      });

      this.submitButton?.addEventListener('click', () => this.onSubmit());
    }

    disconnectedCallback() {
      this.unsubscribeVariantChange?.();
    }

    onTierChange() {
      this.tiers.forEach((tier) => {
        const radio = tier.querySelector('.pack-deal__radio-input');
        tier.classList.toggle('pack-deal__tier--selected', !!radio?.checked);
      });
      this.setError('');
    }

    wireRow(row) {
      const productGroup = row.querySelector('[data-row-product-group]');
      const sizeGroup = row.querySelector('[data-row-size-group]');
      if (productGroup && sizeGroup) {
        productGroup.querySelectorAll('.pack-deal__dropdown-option').forEach((option) => {
          option.addEventListener('click', () => this.rebuildSizeOptions(row, productGroup, sizeGroup));
        });
      }

      row.querySelectorAll('[data-row-option]').forEach((group) => this.wireDropdown(group, row));
    }

    rebuildSizeOptions(row, productGroup, sizeGroup) {
      const selectedProduct = productGroup.querySelector('.pack-deal__dropdown-option.is-selected');
      const productId = selectedProduct?.dataset.productId ? Number(selectedProduct.dataset.productId) : null;
      const entry = productId ? this.choiceProductsById.get(productId) : null;
      if (!entry) return;

      const sizeOptionIndex = entry.optionNames.findIndex((name) => !['color', 'colour'].includes(name.toLowerCase()));
      if (sizeOptionIndex === -1) return;

      const previousValue = sizeGroup.querySelector('.pack-deal__dropdown-option.is-selected')?.dataset.value;
      const seen = new Set();
      const sizeValues = [];
      entry.variants.forEach((variant) => {
        const value = variant.options[sizeOptionIndex];
        if (value && !seen.has(value)) {
          seen.add(value);
          sizeValues.push(value);
        }
      });
      if (sizeValues.length === 0) return;
      const nextValue = sizeValues.includes(previousValue) ? previousValue : sizeValues[0];

      const list = sizeGroup.querySelector('[data-dropdown-list]');
      const toggleLabel = sizeGroup.querySelector('[data-dropdown-toggle-label]');
      list.innerHTML = '';
      sizeValues.forEach((value) => {
        const option = document.createElement('li');
        option.className = 'pack-deal__dropdown-option';
        option.setAttribute('role', 'option');
        option.dataset.value = value;
        const isSelected = value === nextValue;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-selected', String(isSelected));
        const label = document.createElement('span');
        label.className = 'pack-deal__dropdown-option-label';
        label.textContent = value;
        option.appendChild(label);
        option.addEventListener('click', () => {
          list.querySelectorAll('.pack-deal__dropdown-option').forEach((other) => {
            other.classList.remove('is-selected');
            other.setAttribute('aria-selected', 'false');
          });
          option.classList.add('is-selected');
          option.setAttribute('aria-selected', 'true');
          if (toggleLabel) toggleLabel.textContent = value;
          sizeGroup.open = false;
          this.resolveRow(row);
        });
        list.appendChild(option);
      });
      if (toggleLabel) toggleLabel.textContent = nextValue;
    }

    wireDropdown(details, row) {
      const summary = details.querySelector('[data-dropdown-toggle]');
      const list = details.querySelector('[data-dropdown-list]');
      const toggleSwatch = details.querySelector('[data-dropdown-toggle-swatch]');
      const toggleLabel = details.querySelector('[data-dropdown-toggle-label]');

      details.addEventListener('toggle', () => {
        list.classList.remove('pack-deal__dropdown-list--upward');
        if (!details.open) return;
        this.querySelectorAll('.pack-deal__dropdown[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });

        const overflowBelow = list.getBoundingClientRect().bottom - window.innerHeight;
        if (overflowBelow > 0 && summary.getBoundingClientRect().top > overflowBelow) {
          list.classList.add('pack-deal__dropdown-list--upward');
        }
      });

      list.querySelectorAll('.pack-deal__dropdown-option').forEach((option) => {
        option.addEventListener('click', () => {
          list.querySelectorAll('.pack-deal__dropdown-option').forEach((other) => {
            other.classList.remove('is-selected');
            other.setAttribute('aria-selected', 'false');
          });
          option.classList.add('is-selected');
          option.setAttribute('aria-selected', 'true');
          const optionSwatch = option.querySelector('.pack-deal__dropdown-option-swatch');
          if (toggleSwatch && optionSwatch) toggleSwatch.innerHTML = optionSwatch.innerHTML;
          if (toggleLabel) toggleLabel.textContent = option.querySelector('.pack-deal__dropdown-option-label').textContent;
          details.open = false;
          this.resolveRow(row);
        });
      });
    }

    getRowSelectedValues(row) {
      const groups = Array.from(row.querySelectorAll('[data-row-option]')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
      return groups.map((group) => {
        const selected = group.querySelector('.pack-deal__dropdown-option.is-selected');
        return selected ? selected.dataset.value : null;
      });
    }

    findVariant(values) {
      return this.variants.find(
        (variant) => variant.options.length === values.length && variant.options.every((val, i) => val === values[i])
      );
    }

    resolveRow(row) {
      const photo = row.querySelector('[data-row-photo]');
      const productGroup = row.querySelector('[data-row-product-group]');

      if (productGroup) {
        const selected = productGroup.querySelector('.pack-deal__dropdown-option.is-selected');
        const sizeGroup = row.querySelector('[data-row-size-group]');

        let resolvedVariantId = null;
        let available = false;
        if (selected && sizeGroup) {
          const productId = selected.dataset.productId ? Number(selected.dataset.productId) : null;
          const entry = productId ? this.choiceProductsById.get(productId) : null;
          const sizeValue = sizeGroup.querySelector('.pack-deal__dropdown-option.is-selected')?.dataset.value;
          const sizeOptionIndex = entry ? entry.optionNames.findIndex((name) => !['color', 'colour'].includes(name.toLowerCase())) : -1;
          const variant = entry && sizeOptionIndex !== -1 && sizeValue ? entry.variants.find((v) => v.options[sizeOptionIndex] === sizeValue) : null;
          if (variant) {
            resolvedVariantId = variant.id;
            available = variant.available;
          }
        } else if (selected) {
          resolvedVariantId = selected.dataset.variantId ? Number(selected.dataset.variantId) : null;
          available = selected.dataset.available === 'true';
        }

        if (resolvedVariantId && available) {
          row.dataset.variantId = resolvedVariantId;
          row.classList.remove('pack-deal__row--unavailable');
        } else {
          delete row.dataset.variantId;
          row.classList.toggle('pack-deal__row--unavailable', !!selected && !available);
        }
        if (photo && selected?.dataset.image) photo.src = selected.dataset.image;
        this.computeTierPrice(row.closest('[data-tier]'));
        return;
      }

      const values = this.getRowSelectedValues(row);
      const variant = values.includes(null) ? null : this.findVariant(values);

      if (variant && variant.available) {
        row.dataset.variantId = variant.id;
        row.classList.remove('pack-deal__row--unavailable');
      } else {
        delete row.dataset.variantId;
        row.classList.toggle('pack-deal__row--unavailable', !!variant && !variant.available);
      }

      if (photo && variant && variant.featured_image && variant.featured_image.src) {
        photo.src = variant.featured_image.src.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_x100$1$2');
      }
      this.computeTierPrice(row.closest('[data-tier]'));
    }

    computeTierPrice(tier) {
      if (!tier) return;
      const rows = Array.from(tier.querySelectorAll('[data-row]')).filter((row) => !row.hidden);

      const resolvePosition = (variantId) => ({
        price: variantId && this.variantPriceById.has(variantId) ? this.variantPriceById.get(variantId) : null,
        compareAt: variantId && this.variantCompareAtById.has(variantId) ? this.variantCompareAtById.get(variantId) : 0,
      });

      const positions =
        rows.length > 0
          ? rows.map((row) => resolvePosition(row.dataset.variantId ? Number(row.dataset.variantId) : null))
          : [resolvePosition(this.currentVariantId)];

      if (positions.length === 0 || positions.some((position) => position.price === null)) return;

      const paidQty = Number.isNaN(Number(tier.dataset.paidQty)) ? 0 : Number(tier.dataset.paidQty);
      const discountPercent = Number(tier.dataset.discountPercent) || 0;

      let discountedTotal = 0;
      positions.forEach((position, index) => {
        const positionDiscount = index + 1 > paidQty ? discountPercent : 0;
        discountedTotal += position.price * (1 - positionDiscount / 100);
      });

      const wasTotal = positions.reduce((sum, position) => sum + Math.max(position.compareAt, position.price), 0);

      const tierPriceNow = Math.round(discountedTotal);
      const tierPriceWas = Math.round(wasTotal);

      const nowEl = tier.querySelector('.pack-deal__price-now');
      const wasEl = tier.querySelector('.pack-deal__price-was');
      if (nowEl) nowEl.textContent = this.formatMoney(tierPriceNow);
      if (wasEl) wasEl.textContent = this.formatMoney(tierPriceWas);
    }

    formatMoney(cents) {
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const format = this.moneyFormat || '${{amount}}';

      const formatWithDelimiters = (number, precision, thousands, decimal) => {
        const fixed = (number / 100).toFixed(precision);
        const parts = fixed.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        return parts[1] ? dollars + decimal + parts[1] : dollars;
      };

      const match = format.match(placeholderRegex);
      let value;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2, ',', '.');
      }

      return format.replace(placeholderRegex, value);
    }

    setError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = !message;
    }

    onSubmit() {
      const selectedTier = this.tiers.find((tier) => tier.querySelector('.pack-deal__radio-input')?.checked);
      if (!selectedTier) return;

      const rows = Array.from(selectedTier.querySelectorAll('[data-row]')).filter((row) => !row.hidden);
      const items = [];
      for (const row of rows) {
        this.resolveRow(row);
        if (!row.dataset.variantId) {
          this.setError(window.PackDealStrings?.selectOptions || 'Please choose an option for every item in this pack.');
          return;
        }
        items.push({ id: Number(row.dataset.variantId), quantity: 1 });
      }

      if (items.length === 0) {
        if (!this.currentVariantId) return;
        const totalQty = Number(selectedTier.dataset.totalQty) || 1;
        items.push({ id: this.currentVariantId, quantity: totalQty });
      }

      const mergedItems = [];
      const mergedIndexById = new Map();
      for (const item of items) {
        if (mergedIndexById.has(item.id)) {
          mergedItems[mergedIndexById.get(item.id)].quantity += item.quantity;
        } else {
          mergedIndexById.set(item.id, mergedItems.length);
          mergedItems.push({ ...item });
        }
      }

      const totalQty = Number(selectedTier.dataset.totalQty) || 1;
      selectedTier.querySelectorAll('.pack-deal__gift-check:checked').forEach((check) => {
        mergedItems.push({
          id: Number(check.dataset.giftVariantId),
          quantity: 1,
          properties: {
            _pack_deal_gift: 'true',
            _pack_deal_gift_min: String(totalQty),
            _pack_deal_gift_products: this.dataset.packProductIds || this.dataset.productId,
          },
        });
      });

      this.setError('');
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.submitButton.querySelector('[data-spinner]');
      if (spinner) spinner.hidden = false;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items: mergedItems };
      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      const { CartLinesUpdateEvent, CartErrorEvent } = window.StandardEvents || {};
      let deferred;
      if (CartLinesUpdateEvent) {
        deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: mergedItems.map((item) => ({ merchandiseId: item.id, quantity: item.quantity })),
            promise: deferred.promise,
          })
        );
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.setError(response.description || response.message || 'Something went wrong.');
            deferred?.reject(new Error(response.description || response.message));
            if (CartErrorEvent) {
              this.dispatchEvent(
                new CartErrorEvent({ error: response.description || response.message, code: 'INVALID' })
              );
            }
            return;
          }
          if (deferred) {
            fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
              .then((r) => (r.ok ? r.json() : null))
              .then((ajaxCart) => {
                deferred.resolve({ cart: ajaxCart ? CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart) : null });
              })
              .catch(() => deferred.resolve({ cart: null }));
          }
          if (cart) {
            cart.renderContents(response);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          } else {
            window.location = window.routes.cart_url;
          }
        })
        .catch((error) => {
          this.setError('Network error - please try again.');
          deferred?.reject(error);
          if (CartErrorEvent) {
            this.dispatchEvent(new CartErrorEvent({ error: error.message, code: 'SERVICE_UNAVAILABLE' }));
          }
        })
        .finally(() => {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          if (spinner) spinner.hidden = true;
        });
    }
  }

  customElements.define('pack-deal-block', PackDealBlock);
}
